module.exports = __webpack_public_path__ + "static/img/dd-partner-05.2b2c1ba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/dd-partner-05.jpg
// module id = bE35
// module chunks = 1